class CartButton extends HTMLElement {
    static ELEMENT_NAME = 'cart-button'

    static SELECTORS = {
        counter: '[data-cart-button-counter]'
    }

    $elements = {
        counter: null
    }

    counter = 0;
    counterVisible = false;

    constructor() {
        super()

        this.$elements.counter = this.querySelector(CartButton.SELECTORS.counter)

        this.counter = this.$elements.counter.textContent ? parseInt(this.$elements.counter.textContent.trim()) : 0;

        // determine whether to show or not show the counter initially
        if (this.counter === 0) {
            this.counterVisible = false;
        }
    }

    /**
     * FUNCTIONS
     */

    setCounter(value) {
        const newValue = Number(value);
        this.counter = isNaN(newValue) ? 0 : newValue;

        if (this.$elements.counter) {
            this.$elements.counter.textContent = this.counter;
        }

        if (this.counter === 0) {
            this.hideCounter();
        } else {
            this.showCounter();
        }
    }

    increaseCounterBy(value) {
        this.setCounter(this.counter + Number(value));
    }

    decreaseCounterBy(value) {
        this.setCounter(this.counter - Number(value));
    }

    showCounter() {
        this.counterVisible = true;
        this.$elements.counter.hidden = false;
    }

    hideCounter() {
        this.counterVisible = false;
        this.$elements.counter.hidden = true;
    }

    /**
     * LIFECYCLE
     */
    connectedCallback() {
    }
}

customElements.define(CartButton.ELEMENT_NAME, CartButton);